import { useLocation, Route, Redirect } from "react-router-dom";

const ExternalRoute = (props) => {
  let location = useLocation();

  return location.pathname === "/payment" ? (
    <Route {...props} />
  ) : (
    <Redirect to="/" />
  );
};

export default ExternalRoute;
